//THEME
// @codekit-append "imports/_performance.js";
// @codekit-append "imports/_main.js";
// @codekit-append "imports/_nav.js";
// @codekit-append "imports/_cookies.js";
// @codekit-append "imports/_modals.js";
// @codekit-append "imports/_images.js";
// @codekit-append "imports/_ajax.js";
// @codekit-append "imports/_gallery.js";
// @codekit-append "imports/_swipebox.js";

//BLOCKS
// @codekit-append "../../inc/blocks/accordion/accordion.js";
// @codekit-append "../../inc/blocks/container/container.js";
// @codekit-append "../../inc/blocks/columns/columns.js";
// @codekit-append "../../inc/blocks/content-builder/content-builder.js";
// @codekit-append "../../inc/blocks/hero-image/hero-image.js";
// @codekit-append "../../inc/blocks/loop/loop.js";
// @codekit-append "../../inc/blocks/tabs/tabs.js";
// @codekit-append "../../inc/blocks/video-loader/video-loader.js";
// @codekit-append "../../inc/blocks/countdown/countdown.js";


//LIBS
// @codekit-append "../../lib/bootstrap/js/bootstrap.custom.js";
// @codekit-append "../../lib/swipebox/src/js/jquery.swipebox.min.js";


//All is well, no errors in above. Now add js class to body for css animation.
document.body.classList.add('wpk-js');